export const VnLocalizedStrings = {
  GlobalLabels: {
    All: "Tất cả",
    NoSort: "Không có",
    Status: "Trạng thái",
    Phone: "Số điện thoại",
    Actions: "Hành động",
    Active: "Hoạt động",
    Inactive: "Không hoạt động",
    Deleted: "Xóa",
    Search: "Tìm kiếm",
    Redo: "Làm mới bộ lọc",
    Cancel: "Quay lại",
    Confirmed: "Xác nhận",
    Detail: "Chi tiết",
    Create: "Thêm mới",
    Password: "Mật khẩu",
    PasswordConfirmed: "Xác nhận mật khẩu",
    Description: "Mô tả",
    Update: "Cập nhật",
    Address: "Địa chỉ",
    Partner: "Đối tác",
    Total: "Tổng cộng",
    NoPartner: "Không thuộc đối tác",
    createdAt: "Ngày tạo",
    updatedAt: "Ngày cập nhật",
    Cover: "Ảnh nền",
    Success: "Thành công",
    Failed: "Thất bại",
    Date: "Ngày",
    Hour: "Giờ",
    ExcelExporting: "Xuất Excel",
    Type: "Loại",
    Regions: "Vùng",
    Login: "Đăng nhập",
    NoInfo: "Không có thông tin",
    ASC: "Tăng dần",
    DESC: "Giảm dần",
    Logout: "Đăng xuất",
    Attention: "Xem lưu ý tại đây"
  },
  GlobalMessage: {
    Email: "Nhập đúng định dạng Email !",
    UpdateSuccessfully: "Cập nhật thành công !",
    UpdateFailed: "Cập nhật thất bại:",
    CreateSuccessfully: "Tạo mới thành công !",
    CreateFailed: "Tạo mới thất bại:",
    DeleteSuccessfully: "Xóa thành công !",
    DeleteFailed: "Xóa thất bại:",
    DeleteConfirmation: "Xác nhận xóa phần tử này ?",
    ResetPassSuccessfully: "Đặt lại mật khẩu thành công !",
    ResetPassFailed: "Đặt lại mật khẩu thất bại:",
    Error: "Đã có lỗi xảy ra",
    Exporting: "Đang xuất Báo cáo...",
    SystemError: "Có lỗi lấy thông tin đăng nhập, quay lại trang đăng nhập...",
    LoginSuccessfully: "Đăng nhập thành công !",
    InvalidAccount:
      "Username hoặc mật khẩu không đúng hoặc User không tồn tại !",
    InvalidMenuConfig:
      "Lỗi không lấy được Menu Sidebar, vui lòng thử lại sau !",
  },
  GlobalPlaceholder: {
    UserName: "Vui lòng nhập user name...",
    Email: "Vui lòng nhập email...",
    Name: "Vui lòng nhập tên...",
    Code: "Vui lòng nhập mã...",
    Partner: "Vui lòng chọn đối tác",
    Status: "Vui lòng chọn trạng thái",
    Phone: "Vui lòng nhập số điện thoại...",
    Password: "Vui lòng nhập mật khẩu",
    PasswordConfirmed: "Mật khẩu xác nhận cần trùng với mật khẩu",
    Description: "Vui lòng nhập mô tả là chữ",
  },
  Sidebar: {
    General: "Tổng quan",
    Management: "Quản lý",
    History: "Lịch sử giao dịch",
    DataTransaction: "Gói cước",
    SystemConfig: "Cấu hình hệ thống",
    DataPackages: "Gói cước Data",
    RoamingPackages: "Gói cước Roaming",
    UserManagement: "Người dùng",
    AffiliateManagement: "Quản lý affiliate",
    OrderList: "Đơn hàng mua sim",
    TravelSimList: "Đăng ký sim du lịch",
    Country: "Quốc gia",
    PlatformConfig: "Platform",
    Contents: "Bài viết",
    Files: "Tệp",
    CDN: "CDN",
    Address: "Tỉnh thành",
  },
  General: {
    Revenue: {
      Day: "Doanh thu hôm nay",
      Week: "Doanh thu tuần này",
      Month: "Doanh thu tháng này",
      LastMonth: "Doanh thu tháng trước",
      WeekOfYear: "Tuần",
    },
    Charts: {
      Title: "Báo cáo tổng hợp",
      Transaction: "Giao dịch",
      TotalRevenue: "Tổng doanh thu",
      SuccessTransaction: "Tổng giao dịch thành công",
    },
  },
  UserManagement: {
    MainTitle: "Quản lý user",
    Total: "Tổng User",
    Columns: {
      UserName: "Tên username",
      FullName: "Họ tên",
      Email: "Email",
      Partner: "Đối tác",
      Phone: "Số điện thoại",
      Balance: "Số dư",
      Role: "Role user",
      ResetPass: "Đặt mật khẩu mới",
      OldPass: "Mật khẩu cũ",
      NewPass: "Mật khẩu mới",
    },
    RuleMessage: {
      Url: "Vui lòng nhập link dưới dạng URL HTTPS",
      Name: "Vui lòng nhập tên",
      Password: "Vui lòng nhập mật khẩu",
      UserName: "Vui lòng nhập username",
      IdUrl: "Vui lòng nhập link tiếp thị",
      IconUrl: "Vui lòng nhập link icon có định dạng jpg, png, jpeg",
      Status: "Vui lòng chọn trạng thái",
      Phone: "Vui lòng nhập số điện thoại gồm 10 chữ số",
      Code: "Vui lòng nhập mã",
      Role: "Vui lòng chọn role cho user",
      Partner: "Vui lòng chọn đối tác ( tùy chọn )",
      InvalidPartner: "Đối tác không hợp lệ",
      Balance: "Vui lòng nhập hạn mức",
    },
  },
  PathConfigManagement: {
    Title: "Quản lý cấu hình",
    Total: "Tổng cộng",
    Columns: {
      Title: "Tên cấu hình",
      Code: "Mã cấu hình",
      Path: "Đường dẫn",
      ImageUrl: "Hình ảnh",
      Description: "Mô tả",
    },
    Placeholder: {
      Title: "Vui lòng nhập tên",
      Path: "Vui lòng nhập đường dẫn",
      ImageUrl: "Vui lòng nhập link hình ảnh dạng URL",
      Description: "Vui lòng nhập mô tả",
    },
    Message: {
      AddConfig: "Vui lòng khai báo cấu hình JSON bên dưới",
    },
  },
  ContentManagement: {
    Title: "Quản lý bài viết",
    Total: "Tổng bài viết",
    Columns: {
      Name: "Tên bài viết",
      Preview: "Xem trước",
      Replace: "Thay bài viết",
      Download: "Tải bài viết",
      Delete: "Xóa bài viết",
      File: "Tệp bài viết",
      Image: "Hình ảnh",
    },
    Message: {
      WrongStructure: "File tải không đúng định dạng !",
      NotExisted: "File tải không tồn tại !",
      Files: "Vui lòng nhập ít nhất một file bài viết",
      OnlyDocx: "Lưu ý: Chỉ nhập file DOCX",
      OnlyImages: " Lưu ý: Chỉ nhập 1 file ảnh PNG, JPEG, JPG",
      MissingAttributes:
        "Vui lòng đặt tên có tiền tố Content đối với file DOC hoặc Image đối với file ảnh !",
      AddAttribute:
        "Vui lòng đặt tên file bài viết có tiền tố Content (Content_abc.docx), file hình ảnh có tiền tố Image (Image_xyz.png)",
    },
  },
  CountryManagement: {
    Title: "Quản lý quốc gia",
    Total: "Tổng quốc gia",
    Columns: {
      Name: "Tên quốc gia",
      Code: "Mã quốc gia",
      Capital: "Thủ đô",
      Region: "Vùng",
      Ensign: "Quốc kỳ",
    },
    Regions: {
      SouthAmerica: "Nam Mỹ",
      NorthAmerica: "Bắc Mỹ",
      NorthPole: "Nam Cực",
      Europe: "Châu Âu",
      Asia: "Châu Á",
      Africa: "Châu Phi",
      Australia: "Châu Đại Dương",
      Asean: "Đông Nam Á",
    },
    Placeholder: {
      Capital: "Vui lòng nhập tên thủ đô",
      Region: "Vui lòng chọn vùng quốc gia",
      Cover: "Vui lòng nhập link hình ảnh dưới dạng URL",
    },
    RoamingPartner: {
      Name: "Tên đối tác",
      Code: "Mã đối tác",
    },
    MobileData: {
      Name: "Tên gói cước",
      Code: "Mã gói cước",
      Price: "Giá gói",
      Handset: "Handset",
      TransferredData: "Nhóm dữ liệu",
      CodeMobileDevice: "Code Mobile Device",
    },
    Message: {
      CoverAttributes: "Vui lòng đặt tên file cover có tiền tố Cover_",
      EnsignAttributes: "Vui lòng chọn một file ảnh quốc kỳ !",
    },
  },
  FileManagement: {
    Title: "Quản lý CDN",
    Upload: "Nhập File",
    Replace: "Thay file",
    Download: "Tải file",
    CopyUrl: "Sao chép URL",
    Placeholder: {
      Type: "Vui lòng chọn loại file",
      File: "Vui lòng nhập ít nhất 1 file từ máy tính",
      Url: "Đã lưu URL vào bộ nhớ tạm",
    },
    Columns: {
      Name: "Tên file",
      Code: "Mã file",
      Size: "Kích thước",
      Type: "Loại tệp",
    },
  },
  RoamingManagement: {
    Title: "Quản lý Gói Roaming",
    Total: "Tổng gói Roaming",
    Add: "Thêm",
    Category: {
      Hot: "Gói hot",
      Day: "Gói ngày",
      Week: "Gói tuần",
      Month: "Gói tháng",
      Roaming: "Gói Roaming",
    },
    PlaceHolder: {
      Cover: "Vui lòng nhập url hình ảnh...",
      Descriptions: "Vui lòng nhập mô tả...",
      ShortDes: "Vui lòng nhập mô tả ngắn gọn...",
      Duration: "Vui lòng nhập thời lượng gói...",
      Price: "Vui lòng nhập giá gói...",
      Storage: "Vui lòng nhập dung lượng gói...",
      DiscountRate: "Vui lòng nhập giảm giá...",
      InternalCallTotalHour: "Vui lòng nhập giờ gọi nội mạng...",
      ExternalCallTotalHour: "Vui lòng nhập giờ gọi ngoại mạng...",
      Category: "Vui lòng chọn loại gói...",
      Country: "Vui lòng chọn quốc gia...",
    },
    Country: {
      Title: "Quốc gia",
      Add: "Thêm quốc gia",
      Edit: "Chỉnh sửa thông tin quốc gia",
    },
    RoamingPartner: {
      Title: "Đối tác",
      Add: "Thêm đối tác",
      Select: "Chọn đối tác",
    },
    Columns: {
      Name: "Tên gói",
      Code: "Mã",
      Cover: "Hình ảnh",
      Description: "Mô tả",
      ShortDescription: "Mô tả ngắn gọn",
      Duration: "Thời lượng gói",
      Price: "Giá",
      Storage: "Dung lượng",
      DiscountRate: "Giảm giá",
      InternalCallTotalHour: "Giờ gọi nội mạng",
      ExternalCallTotalHour: "Giờ gọi ngoại mạng",
      Action: "Hành động",
      Country: "Quốc gia",
      Region: "Khu vực",
      Category: "Loại gói",
      Order: "Thứ tự",
      Type: "Loại",
      SimType: "Loại Sim",
    },
  },
  TopupManagement: {
    Title: "Quản lý gói cước Data",
    Total: "Tổng gói cước",
    Add: "Thêm thông tin",
    AddShort: "Thêm mô tả ngắn",
    AddMore: "Thêm thông tin chi tiết gói",
    More: "Thông tin chi tiết gói",
    MoreInfoName: "Tên thông tin",
    MoreInfoItems: "Thông tin",
    ShortDescription: "Mô tả ngắn",
    Oder: "Theo độ ưu tiên",
    Columns: {
      Name: "Tên gói",
      Code: "Mã gói",
      Order: "Độ ưu tiên",
      DurationDay: "Thời hạn",
      Price: "Giá gói",
      Storage: "Dung lượng",
      Category: "Loại gói",
      InternalCallTotalHour: "Gọi nội mạng",
      ExternalCallTotalHour: "Gọi ngoại mạng",
    },
    Category: {
      Hot: "Gói hot",
      Day: "Gói ngày",
      Week: "Gói tuần",
      Month: "Gói tháng",
    },
    Placeholder: {
      DurationDay: "Vui lòng nhập thời lượng gói",
      Price: "Vui lòng nhập giá gói thấp nhất 1,000 VND !",
      Storage: "Vui lòng nhập dung lượng là số !",
      Cover: "Vui lòng nhập link ảnh dưới dạng URL !",
      Category: "Vui lòng chọn loại gói cước",
    },
    SyncFromB2B: {
      Title: "Thêm gói data từ B2B",
      Confirm: "Bạn có chắc chắn muốn thêm các gói",
      InvalidPackages: "Vui lòng chọn một gói cước",
    },
  },
  TransactionHistory: {
    Title: "Lịch sử giao dịch gói cước",
    Total: "Tổng giao dịch",
    NoTransRef: "Không mã tham chiếu",
    Customer: "Khách hàng mua lẻ",
    Details: "Chi tiết giao dịch",
    Message: {
      PartnerListError: "Lỗi danh sách đối tác",
    },
    Status: {
      Init: "Khởi tạo",
      Progerssing: "Đang xử lý",
      Finished: "Hoàn thành",
      Error: "Lỗi",
      Deleted: "Đã xóa",
      WaitingToBeConfirmed: "Chờ xác nhận",
    },
    Placeholder: {
      Code: "Nhập mã giao dịch",
      ID: "Nhập ID giao dịch",
      TransRef: "Nhập mã tham chiếu",
    },
    Columns: {
      ID: "ID giao dịch",
      Code: "Mã giao dịch",
      TransRef: "Mã tham chiếu",
      PackageName: "Tên gói",
      Phone: "Số điện thoại",
      Partner: "Đối tác",
      Method: "Phương thức",
      TotalAmount: "Tổng tiền",
    },
  },
  AddressManagement: {
    Title: "Quản lý Tỉnh thành",
    DataType: "Dữ liệu danh sách",
    Province: "Danh sách Tỉnh, Thành phố lớn",
    District: "Danh sách Quận, Huyện",
    Wards: "Danh sách Phường, Xã",
    Columns: {
      Name: "Tên",
      Code: "Mã",
      FullName: "Tên đầy đủ",
      FullNameEn: "Tên tiếng Anh đầy đủ",
      Province: "Tỉnh, thành phố lớn",
      District: "Quận, huyện",
      NameEn: "Tên tiếng Anh",
      Ward: "Phường, xã",
    },
    Placeholder: {
      Units: "Vui lòng chọn loại",
      Regions: "Vui lòng chọn vùng",
    },
  },
  ChangePassword: {
    Title: "Đổi mật khẩu",
    OldPass: "Mật khẩu cũ",
    NewPass: "Mật khẩu mới",
    Reconfirmed: "Xác nhận mật khẩu mới",
    Message: {
      InvalidPass: "Vui lòng xác nhận mật khẩu",
      OldPass: "Vui lòng nhập mật khẩu cũ",
      NewPass: "Vui lòng nhập mật khẩu mới",
      UnmatchedPass: "Mật khẩu xác nhận không trùng khớp",
      ChangePassSucceed: "Bạn đã đổi mật khẩu thành công !",
    },
  },
  SimOrdersForPartners: {
    Title: "Danh sách thông tin đăng ký Sim",
    Columns: {
      CreatedAt: "Thời gian tạo",
      OrderCode: "Mã đơn hàng",
      Sim: "Số Sim",
      PackageType: "Loại gói",
      CustomerName: "Tên khách hàng",
      CustomerPhone: "Số điện thoại khách hàng",
      Address: "Địa chỉ giao hàng",
      Email: "Email khách hàng",
      Partner: "Đối tác",
    },
    Status: {
      WaitingForPurchased: "Chờ thanh toán",
      WaitingForDelivered: "Chờ giao hàng",
      WaitingForRecieved: "Chờ nhận hàng",
      Success: "Giao hàng thành công",
      Canceled: "Đã hủy",
      ConnectedSuccessfully: "Hòa mạng thành công",
      ConnectedFailed: "Hòa mạng thất bại",
    },
    Message: {
      ExcelError: "Lỗi xuất báo cáo",
      InvalidSim: "Số sim không được để trống",
      InvalidPackages: "Nhập số sim để hiện thông tin gói",
      InvalidOrderCode: "Mã đơn hàng không để trống",
      InvalidPhone: "Điện thoại liên hệ không được trống hoặc quá 10 số !",
      Address: "Vui lòng nhập địa chỉ khách hàng",
    },
  },
  TravelSimListManagement: {
    Title: "Danh sách thông tin đăng ký sim du lịch",
    Placeholder: "Vui lòng nhập ",
    Detail: "Thông tin chi tiết",
    Gender: {
      Male: "Nam",
      Female: "Nữ",
    },
    Labels: {
      Status: "Trạng thái",
      Type: "Loại",
      Name: "Tên khách hàng",
      ProfileId: "Mã hồ sơ",
      Serial: "Số serial",
      Sim: "Số sim",
      Detail: "Chi tiết",
      Time: "Thời gian tạo",
      IdNumber: "Mã định danh",
      Birthday: "Ngày sinh",
      Sex: "Giới tính",
      Address: "Địa chỉ",
      PlaceOfOrigin: "Quê quán",
      IssueDate: "Ngày cấp",
      IssuePlace: "Nơi cấp",
      PhoneContact: "Số điện thoại",
      EmailContact: "Email",
      ImagesPath: "Các loại giấy tờ",
    },
    ImagePaths: {
      portrait: "Ảnh chân dung",
      front: "Mặt trước",
      back: "Mặt sau",
      sign: "Chữ ký",
    },
    Status: {
      init: "Khởi tạo",
      isOCR: "Đã OCR",
      verified: "Đã xác thực",
      progress: "Đang xử lý",
      success: "Thành công",
      error: "Thất bại",
    },
    Type: {
      cccd: "CCCD",
      passport: "Hộ chiếu",
    },
  },
  RoamingRegistration: {
    Title: "Đăng ký gói cước cho User",
    ModalTitle: "Đăng ký gói cước cho thuê bao",
    Action: "Chọn gói",
    Phone: "Thuê bao cần đăng ký",
    Register: "Đăng ký",
    AddToList: "Thêm vào danh sách đăng ký",
    AssingedList: "Danh sách đăng ký",
    PhoneRegisteredListColumns: {
      Name: "Tên khách hàng",
      Phone: "Thuê bao đăng ký",
      Address: "Địa chỉ",
      Price: "Tổng tiền",
      Email: "Email",
    },
    Columns: {
      Name: "Tên gói",
      Code: "Mã gói",
      Type: "Loại gói",
      Duration: "Thời hạn",
      Capacity: "Dung lượng",
      Price: "Giá gói",
      PartnerTransId: "Mã tham chiếu của đối tác",
    },
    Placehoder: {
      Phone: "Vui lòng nhập số điện thoại...",
    },
    Message: {
      Success: "Đăng ký gói cước thành công",
      Failed: "Đăng ký gói cước cho thuê bao thất bại",
      Error: "Có lỗi xảy ra",
      InvalidPackageAndPhone:
        "Vui lòng chọn một gói cước và nhập thuê bao cần đăng ký để đi tiếp !",
      InvalidPackage: "Vui lòng chọn một gói cước !",
      InvalidPhone: "Vui lòng nhập số thuê bao cần đăng ký gói !",
      RegisterSuccessfully: "Đăng ký gói cước cho thuê bao thành công !",
      PhoneRegistrationWarning:
        "Đây là danh sách tham khảo, vui lòng tìm kiếm với số thuê bao cần đăng ký để hiện danh sách gói phù hợp",
      PhoneRegistrationConfirm: "Xác nhận đăng ký gói",
      ForPhone: "cho thuê bao",
      BasePackagesExisted: "Thuê bao cần đăng ký đang có gói nền",
      RemoveBasePackages: "vui lòng hủy gói nền trước khi đăng ký gói mới !",
      PackagesForSearchedPhone: "Danh sách gói cước cho thuê bao",
      NotMobifone: "Thuê bao không thuộc đầu số Mobifone, vui lòng thử lại !",
      EmptyAssignedList: "Danh dách đăng ký đang rỗng !",
      InvalidPartnerTransId: "Vui lòng nhập mã tham chiếu đối tác !",
      InvalidPhoneLength: "Vui lòng nhập số điện thoại đủ 10 số !",
    },
  },
  BalanceHistory: {
    Title: "Lịch sử điều chỉnh số dư",
    Approve: "Duyệt",
    Reject: "Từ chối",
    Add: "Tạo phiếu",
    Type: {
      0: "Phiếu tăng",
      1: "Phiếu giảm",
    },
    Status: {
      0: "Đang chờ duyệt",
      1: "Duyệt",
      2: "Từ chối",
    },
    ApplicableType: {
      0: "Người dùng",
      1: "Đối tác",
    },
    Placeholder: {
      Type: "Vui lòng chọn loại phiếu",
      ApplicableType: "Vui lòng chọn đối tượng áp dụng",
      Amount: "Vui lòng nhập số tiền yêu cầu ít nhất 1000 VND",
      Phone:
        "Chọn đối tượng áp dụng và người dùng hoặc đối tác để lấy số điện thoại",
      Partner: "Vui lòng chọn một đối tác",
      User: "Vui lòng chọn một người dùng",
    },
    Columns: {
      code: "Mã",
      phone: "Số điện thoại",
      before: "Số dư trước khi duyệt",
      after: "Số dư sau khi duyệt",
      amount: "Số tiền yêu cầu",
      balance: "Số dư ví",
      applicableType: "Đối tượng áp dụng",
      type: "Loại",
      status: "Trạng thái",
      createdBy: "Người tạo",
      updatedBy: "Người duyệt",
      description: "Mô tả",
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
    },
    Message: {
      CreateSuccessfully: "Tạo phiếu thành công !",
      CreateFailed: "Tạo phiếu thất bại !",
      ApproveSuccessfully: "Duyệt phiếu thành công !",
      ApproveFailed: "Duyệt phiếu thất bại",
      RejectSuccessfully: "Từ chối phiếu thành công !",
      RejectFailed: "Từ chối phiếu thất bại",
    },
  },
  PartnerManagement: {
    Normal: "Normal",
    MainTitle: "Quản lý đối tác",
    ipnUrl: "IPN Url",
    Total: "Tổng đối tác",
    CreateUserAfter: "Sau khi tạo đối tác thành công, sẽ tự động tạo một thông tin người dùng cho đối tác đó",
    UserPartner: "Thông tin người dùng cho đối tác",
    CopyUserInfo: "Đã lưu thông tin người dùng của đối tác vào bộ nhớ tạm",
    Columns: {
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      balance: "Số dư",
      type: "Loại",
      status: "Trạng thái",
      affiliateUrl: "Đường dẫn Affiliate",
      createdAt: "Ngày tạo",
    },
    Filters: {
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      type: "Loại",
      status: "Trạng thái",
    },
    Detail: {
      id: "ID",
      name: "Tên đối tác",
      code: "Mã đối tác",
      email: "Email",
      phone: "Số điện thoại",
      type: "Loại",
      status: "Trạng thái",
      publicKey: "Khóa đối tác",
      whnSupplierCode: "Mã nhà cung cấp WHN",
      token: "Token",
      affiliateUrl: "Đường dẫn Affiliate",
      icon: "Đường dẫn Icon",
      address: "Địa chỉ",
      ipnUrl: "Đường dẫn IPN"
    },
    Placeholder: {
      SavedPass: "Đã lưu mật khẩu vào bộ nhớ tạm",
      SavesName: "Đã lưu tên tài khoản vào bộ nhớ tạm"
    },
    UserInfo: {
      userName: "Tên tài khoản",
      password: "Mật khẩu",
      phone: "Số điện thoại",
      address: "Địa chỉ",
      balance: "Số dư",
      type: "Loại",
      status: "Trạng thái"
    }
  },
};
